module.exports = __webpack_public_path__ + "static/media/daniel-korpai-HyTwtsk8XqA-unsplash.c1bba926.jpg";